import React from 'react'
import styles from './styles.module.scss'

const Spinner = ({ type, style }) => {
  return <div style={style} className={`${styles.wrapper} ${type === 'sm' ? styles.wrapperSm : ''}`} />
}
export default Spinner
